import lottie from '../../node_modules/lottie-web/build/player/lottie_light.js';
import { ScrollTrigger } from "../../node_modules/gsap/ScrollTrigger.js";

let mastheadTop = lottie.loadAnimation({
  container: document.getElementById('masthead-top-lottie'),
  renderer: 'svg',
  loop: false,
  autoplay: false,
  path: 'lottie/masthead_top.json'
})

let mastheadTopMd = lottie.loadAnimation({
  container: document.getElementById('masthead-top-lottie-md'),
  renderer: 'svg',
  loop: false,
  autoplay: false,
  path: 'lottie/masthead_top_md.json'
})

mastheadTop.addEventListener("DOMLoaded", function(e) {
  ScrollTrigger.create({
    trigger: "#masthead-top #masthead-top-lottie",
    start: "top 70%",
    end: "bottom top",
    onEnter: function() {
      mastheadTop.play();
    },
    onEnterBack: function() {
      mastheadTop.play();
    },
    onLeave: function() {
      mastheadTop.stop();
    },
    onLeaveBack: function() {
      mastheadTop.stop();
    }
  });

  ScrollTrigger.create({
    trigger: "#masthead-top #masthead-top-lottie-md",
    start: "top 70%",
    end: "bottom top",
    onEnter: function() {
      mastheadTopMd.play();
    },
    onEnterBack: function() {
      mastheadTopMd.play();
    },
    onLeave: function() {
      mastheadTopMd.stop();
    },
    onLeaveBack: function() {
      mastheadTopMd.stop();
    }
  });
});

let mastheadBottom = lottie.loadAnimation({
  container: document.getElementById('masthead-bottom-lottie'),
  renderer: 'svg',
  loop: false,
  autoplay: false,
  path: 'lottie/masthead_bottom_v5.json'
})

let shareLeft = lottie.loadAnimation({
  container: document.getElementById('share-left-lottie'),
  renderer: 'svg',
  loop: false,
  autoplay: false,
  path: 'lottie/share_left_v3.json'
})

let shareRight = lottie.loadAnimation({
  container: document.getElementById('share-right-lottie'),
  renderer: 'svg',
  loop: false,
  autoplay: false,
  path: 'lottie/share_right_v3.json'
})

let thankYou = lottie.loadAnimation({
  container: document.getElementById('thank-you-animation'),
  renderer: 'svg',
  loop: false,
  autoplay: false,
  path: 'lottie/thank_you.json'
})

let thankYouMd = lottie.loadAnimation({
  container: document.getElementById('thank-you-animation-md'),
  renderer: 'svg',
  loop: false,
  autoplay: false,
  path: 'lottie/thank_you_md.json'
})

let workSlider = lottie.loadAnimation({
  container: document.getElementById('work-slider-animation'),
  renderer: 'svg',
  loop: false,
  autoplay: false,
  path: 'lottie/work_slider.json'
})

let workSliderMd = lottie.loadAnimation({
  container: document.getElementById('work-slider-animation-md'),
  renderer: 'svg',
  loop: false,
  autoplay: false,
  path: 'lottie/work_slider_md.json'
})

let workSliderSm = lottie.loadAnimation({
  container: document.getElementById('work-slider-animation-sm'),
  renderer: 'svg',
  loop: false,
  autoplay: false,
  path: 'lottie/work_slider_md.json'
})

ScrollTrigger.create({
  trigger: "#masthead-bottom",
  start: "top 70%",
  end: "bottom top",
  onEnter: function() {
    mastheadBottom.play();
  },
  onEnterBack: function() {
    mastheadBottom.play();
  },
  onLeave: function() {
    mastheadBottom.stop();
  },
  onLeaveBack: function() {
    mastheadBottom.stop();
  }
});

ScrollTrigger.create({
  trigger: "#share",
  start: "top bottom",
  end: "bottom top",
  onEnter: function() {
    shareLeft.play();
    shareRight.play();
  },
  onEnterBack: function() {
    shareLeft.play();
    shareRight.play();
  },
  onLeave: function() {
    shareLeft.stop();
    shareRight.stop();
  },
  onLeaveBack: function() {
    shareLeft.stop();
    shareRight.stop();
  }
});

ScrollTrigger.create({
  trigger: "#thank-you #thank-you-animation",
  start: "top 30%",
  end: "bottom top",
  onEnter: function() {
    thankYou.play();
  }
});

ScrollTrigger.create({
  trigger: "#thank-you #thank-you-animation-md",
  start: "top 70%",
  end: "bottom top",
  onEnter: function() {
    thankYouMd.play();
  }
});

ScrollTrigger.create({
  trigger: "#work-slider-animation",
  start: "bottom bottom",
  end: "bottom top",
  onEnter: function() {
    workSlider.play();
  }
});

ScrollTrigger.create({
  trigger: "#work-slider-animation-md",
  start: "bottom bottom",
  end: "bottom top",
  onEnter: function() {
    workSliderMd.play();
  }
});

ScrollTrigger.create({
  trigger: "#work-slider-animation-sm",
  start: "bottom bottom",
  end: "bottom top",
  onEnter: function() {
    workSliderSm.play();
  }
});
